module.exports = __webpack_public_path__ + "img/rove.c3df8a1.webp";